var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url && !_vm.isTotem)?_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.url,"width":"100%","height":"300","allowfullscreen":"","loading":"lazy"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }